import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/workspace/public/images/passenger-og.png");
import(/* webpackMode: "eager" */ "/workspace/src/components/Navigation/Footer.tsx");
import(/* webpackMode: "eager" */ "/workspace/src/components/Navigation/Nav.tsx");
import(/* webpackMode: "eager" */ "/workspace/src/components/UI/Button.tsx")